import request from '@/plugin/axios'

export function apicommissionApplyById (params) {
    console.log(params);
    return request({
      url:'/api/commissionApplyById',
      method: 'get',
      params:params
    })
  }
  export function apioperateFullCommissionApproval (data) {
    return request({
      url:'/api/operateFullCommissionApproval',
      method: 'post',
      data:data
    })
  }